// extracted by mini-css-extract-plugin
export default {"container":"conversations_container__+P6Vc","--collapsed":"conversations_--collapsed__mIxTQ","--mobile":"conversations_--mobile__0sJiS"};